module.exports = __webpack_public_path__ + "img/spezialisierungen_1280.d7789c1c.webp";